import { useState, type ReactNode } from 'react'
import { QueryClientProvider } from '@tanstack/react-query'
import { SessionProvider } from '@/features/auth/SessionProvider'
import { LanguageProvider } from '@/features/language/LanguageProvider'
import { ThemeProvider } from '@/features/theme/ThemeProvider'
import { createQueryClient } from './query-client'

export function AppProviders({ children }: { children: ReactNode }) {
  const [queryClient] = useState(createQueryClient)

  return (
    <QueryClientProvider client={queryClient}>
      <SessionProvider>
        <LanguageProvider>
          <ThemeProvider>{children}</ThemeProvider>
        </LanguageProvider>
      </SessionProvider>
    </QueryClientProvider>
  )
}
